import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { FaUser, FaEnvelope, FaLock, FaPhoneAlt, FaGlobe, FaCheckCircle, FaTimes } from "react-icons/fa";

function SignUp() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    countryCode: "+20",
    phone: "",
    password: "",
    confirmPassword: "",
  });

  const [termsAccepted, setTermsAccepted] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const countries = [
    { code: "+20", name: "مصر" },
    { code: "+966", name: "السعودية" },
    { code: "+971", name: "الإمارات" },
    { code: "+965", name: "الكويت" },
    { code: "+974", name: "قطر" },
    { code: "+968", name: "عمان" },
    { code: "+973", name: "البحرين" },
    { code: "+1", name: "USA/Canada" },
    { code: "+44", name: "UK" }
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSignUp = async (e) => {
    e.preventDefault();
    setError("");

    if (formData.password.length < 6) {
      setError("كلمة المرور يجب أن لا تقل عن 6 أحرف!");
      return;
    }

    if (formData.password !== formData.confirmPassword) {
      setError("كلمتا المرور غير متطابقتين!");
      return;
    }

    if (!termsAccepted) {
      setError("يجب الموافقة على الشروط والأحكام أولاً.");
      return;
    }

    setLoading(true);

    try {
      const API_URL = window.location.hostname === 'localhost' ? 'http://localhost/api/register.php' : '/api/register.php';
      
      const fullPhoneNumber = formData.countryCode + formData.phone.replace(/^0+/, '');

      const response = await axios.post(API_URL, {
        full_name: formData.fullName,
        email: formData.email,
        phone: fullPhoneNumber,
        password: formData.password
      }, {
        headers: { 'Content-Type': 'application/json' }
      });

      if (response.data.status === "success") {
        setLoading(false);
        navigate("/signin", { state: { message: "تم إنشاء الحساب بنجاح، يمكنك تسجيل الدخول الآن." } });
      } else {
        setLoading(false);
        setError(response.data.message || "حدث خطأ غير معروف");
      }
    } catch (err) {
      setLoading(false);
      setError(err.response?.data?.message || "حدث خطأ في الاتصال بالخادم");
    }
  };

  const TermsModal = () => (
    <div className="terms-modal-overlay">
      <div className="terms-modal-content glass-card">
        <button className="close-btn" onClick={() => setShowTerms(false)}><FaTimes /></button>
        <h2>الشروط والأحكام (Terms & Conditions)</h2>
        <div className="terms-body">
          <div className="terms-section">
            <h3>كوديكال – الشروط والأحكام العالمية وسياسة الدفع</h3>
            <p><strong>1. المقدمة:</strong> مرحبًا بك في كوديكال. من خلال التعاقد على خدماتنا، فإنك تقر بأنك قرأت وفهمت ووافقت على الالتزام بهذه الشروط والأحكام وسياسة الدفع. تسري هذه الشروط على جميع العملاء حول العالم.</p>
            <p><strong>2. نطاق الخدمات:</strong> تقدم كوديكال خدمات تطوير البرمجيات، تصميم المواقع، التسويق الرقمي، الهوية البصرية، أنظمة الأتمتة، والاستشارات التقنية. ويتم تحديد نطاق العمل بدقة لكل مشروع وفقًا للاتفاق.</p>
            <p><strong>3. الاتفاق والموافقة على المشروع:</strong> يتطلب بدء أي مشروع وجود اتفاق واضح ومكتوب يحدد نطاق العمل، الجدول الزمني، والمخرجات. يجب الحصول على موافقة العميل في المراحل الأساسية. وأي طلبات إضافية خارج النطاق المتفق عليه قد تخضع لرسوم إضافية.</p>
            <p><strong>4. شروط الدفع:</strong> يتم دفع مقدم غير قابل للاسترداد قبل بدء أي مشروع. يتم سداد المبلغ المتبقي بناءً على مراحل المشروع أو قبل التسليم النهائي. يتم قبول المدفوعات عبر وسائل الدفع المحلية أو الدولية المعتمدة. قد يؤدي التأخير في الدفع إلى إيقاف العمل مؤقتًا.</p>
            <p><strong>5. سياسة الاسترداد:</strong> جميع المدفوعات غير قابلة للاسترداد بعد بدء العمل. في حالة الإلغاء، يتم تسليم العمل المنجز بما يتناسب مع المبلغ المدفوع.</p>
            <p><strong>6. سياسة التعديلات:</strong> توفر كوديكال عددًا محدودًا من التعديلات حسب الباقة أو الاتفاق. أي تعديلات إضافية أو تغييرات جوهرية خارج نطاق العمل سيتم احتسابها برسوم إضافية.</p>
            <p><strong>7. مدة التنفيذ:</strong> المدد الزمنية تقديرية وتعتمد على سرعة استجابة العميل والموافقات. أي تأخير من جانب العميل قد يؤدي إلى تمديد مدة التسليم.</p>
            <p><strong>8. مسؤوليات العميل:</strong> يلتزم العميل بتوفير جميع المحتويات والملفات المطلوبة والتغذية الراجعة في الوقت المناسب. لا تتحمل كوديكال مسؤولية أي تأخير ناتج عن تأخر أو نقص في مدخلات العميل.</p>
            <p><strong>9. الملكية الفكرية:</strong> تنتقل ملكية المخرجات النهائية للعميل فقط بعد سداد كامل المستحقات. تحتفظ كوديكال بحق عرض الأعمال في معرض أعمالها ما لم يتم الاتفاق على خلاف ذلك.</p>
            <p><strong>10. السرية:</strong> يلتزم الطرفان بالحفاظ على سرية المعلومات وعدم مشاركتها مع أي طرف ثالث.</p>
            <p><strong>11. تحديد المسؤولية:</strong> لا تتحمل كوديكال أي مسؤولية عن الأضرار غير المباشرة أو العرضية أو الناتجة عن استخدام خدماتها.</p>
            <p><strong>12. إنهاء الخدمة:</strong> يحق لكوديكال إنهاء أو إيقاف الخدمة في حال مخالفة الشروط أو عدم السداد أو إساءة الاستخدام.</p>
            <p><strong>13. التعديلات على الشروط:</strong> يحق لكوديكال تعديل هذه الشروط في أي وقت. ويُعد استمرار استخدام الخدمات موافقة على التعديلات.</p>
            <p><strong>14. القانون الحاكم:</strong> تخضع هذه الشروط للقوانين التجارية الدولية المعمول بها.</p>
            <hr />
            <h3>Codical – Global Terms & Conditions & Payment Policy</h3>
            <p><strong>1. Introduction:</strong> Welcome to Codical. By engaging with our services, you acknowledge that you have read, understood, and agreed to be bound by these Terms & Conditions and Payment Policy. These terms apply to all clients globally.</p>
            <p><strong>2. Scope of Services:</strong> Codical provides software development, website design, digital marketing, branding, automation systems, and IT consultancy. The exact scope of work is defined per project agreement.</p>
            <p><strong>3. Project Agreement & Approval:</strong> All projects require clear written agreement on scope, timeline, and deliverables before starting. Client approval is mandatory at key stages. Any additional requests beyond the agreed scope may be subject to extra charges.</p>
            <p><strong>4. Payment Terms:</strong> A non-refundable upfront payment is required before starting any project. Remaining balance is paid based on milestones or before final delivery. Payments are accepted via approved international or local payment methods. Delayed payments may result in project suspension.</p>
            <p><strong>5. Refund Policy:</strong> All payments made are non-refundable once the project has started. In case of cancellation, any completed work will be delivered proportional to the amount paid.</p>
            <p><strong>6. Revisions Policy:</strong> Codical offers a limited number of revisions based on the package or agreement. Excessive revisions or major changes outside scope will be charged additionally.</p>
            <p><strong>7. Delivery Timeline:</strong> Project timelines are estimates and depend on client responsiveness and approval speed. Delays from the client side may extend delivery time.</p>
            <p><strong>8. Client Responsibilities:</strong> Clients must provide all required content, assets, and feedback in a timely manner. Codical is not responsible for delays caused by missing or late client inputs.</p>
            <p><strong>9. Intellectual Property:</strong> Final deliverables become the client’s property only after full payment is completed. Codical reserves the right to showcase completed work in its portfolio unless agreed otherwise.</p>
            <p><strong>10. Confidentiality:</strong> Both parties agree to keep confidential information private and not disclose it to third parties.</p>
            <p><strong>11. Liability Limitation:</strong> Codical is not liable for any indirect, incidental, or consequential damages arising from the use of its services.</p>
            <p><strong>12. Termination:</strong> Codical reserves the right to terminate or suspend services in case of policy violation, non-payment, or misuse.</p>
            <p><strong>13. Modifications:</strong> Codical may update these terms at any time. Continued use of services implies acceptance of updates.</p>
            <p><strong>14. Governing Law:</strong> These terms are governed by applicable international business laws.</p>
          </div>
        </div>
        <button className="btn-primary modal-action" onClick={() => { setTermsAccepted(true); setShowTerms(false); }}>أوافق على الشروط والأحكام</button>
      </div>
    </div>
  );

  return (
    <div className="auth-page">
      <div className="auth-container glass-card">
        <div className="auth-header">
          <FaUser className="auth-icon" />
          <h2>انضم إلى CodiCal</h2>
          <p>قم بإنشاء حسابك لإدارة مشاريعك الطبية الذكية</p>
        </div>

        <form onSubmit={handleSignUp} className="auth-form">
          <div className="input-group">
            <FaUser className="input-icon" />
            <input type="text" name="fullName" placeholder="الاسم الكامل" required value={formData.fullName} onChange={handleChange} />
          </div>

          <div className="input-group">
            <FaEnvelope className="input-icon" />
            <input type="email" name="email" placeholder="البريد الإلكتروني" required value={formData.email} onChange={handleChange} />
          </div>

          <div className="input-group phone-group">
            <div className="country-select-wrapper">
              <FaGlobe className="input-icon-left" />
              <select name="countryCode" value={formData.countryCode} onChange={handleChange} className="country-select">
                {countries.map(c => <option key={c.code} value={c.code}>{c.code} ({c.name})</option>)}
              </select>
            </div>
            <input type="tel" name="phone" placeholder="رقم الهاتف (بدون الصفر الأول)" required value={formData.phone} onChange={handleChange} dir="ltr" />
            <FaPhoneAlt className="input-icon" style={{right: '15px'}} />
          </div>

          <div className="input-group">
            <FaLock className="input-icon" />
            <input type="password" name="password" placeholder="كلمة المرور (6 أحرف على الأقل)" required value={formData.password} onChange={handleChange} />
          </div>

          <div className="input-group">
            <FaCheckCircle className="input-icon" />
            <input type="password" name="confirmPassword" placeholder="تأكيد كلمة المرور" required value={formData.confirmPassword} onChange={handleChange} />
          </div>

          <div className="terms-checkbox-group">
            <input type="checkbox" id="termsAccepted" checked={termsAccepted} onChange={(e) => setTermsAccepted(e.target.checked)} />
            <label htmlFor="termsAccepted">لقد قرأت وأوافق على <span className="terms-link" onClick={(e) => { e.preventDefault(); setShowTerms(true); }}>الشروط والأحكام وسياسة الدفع</span></label>
          </div>

          {error && <p className="error-message fade-in">{error}</p>}

          <button type="submit" className="auth-btn" disabled={loading || !termsAccepted}>
            {loading ? <span className="spinner"></span> : "إنشاء حساب"}
          </button>
        </form>

        <div className="auth-footer">
          <p>لديك حساب بالفعل؟ <Link to="/signin">تسجيل الدخول</Link></p>
        </div>
      </div>

      {showTerms && <TermsModal />}

      <style>{`
        .auth-page {
          min-height: 100vh;
          display: flex;
          justify-content: center;
          align-items: center;
          background: var(--bg-color);
          padding: 40px 20px;
          font-family: 'Tajawal', sans-serif;
          position: relative;
          overflow: hidden;
          transition: all 0.3s ease;
        }

        .auth-page::before {
          content: "";
          position: absolute;
          width: 400px;
          height: 400px;
          background: radial-gradient(circle, rgba(255,107,53,0.15) 0%, rgba(255,107,53,0) 70%);
          top: -100px;
          left: -100px;
          border-radius: 50%;
          z-index: 0;
        }

        .glass-card {
          background: var(--card-bg);
          backdrop-filter: blur(20px);
          -webkit-backdrop-filter: blur(20px);
          border: 1px solid var(--border-color);
          border-radius: 20px;
          box-shadow: 0 15px 35px rgba(0,0,0,0.1);
          z-index: 1;
        }

        .auth-container {
          width: 100%;
          max-width: 500px;
          padding: 40px;
          color: var(--text-color);
          animation: slideUp 0.6s ease-out;
        }

        .auth-header {
          text-align: center;
          margin-bottom: 30px;
        }

        .auth-icon {
          font-size: 40px;
          color: var(--primary);
          margin-bottom: 15px;
        }

        .auth-header h2 {
          font-size: 28px;
          margin-bottom: 10px;
          font-weight: 700;
          color: var(--text-color);
        }

        .auth-header p {
          color: var(--text-color);
          opacity: 0.7;
          font-size: 15px;
        }

        .auth-form {
          display: flex;
          flex-direction: column;
          gap: 20px;
        }

        .input-group {
          position: relative;
          display: flex;
          align-items: center;
        }

        .phone-group {
          display: flex;
          gap: 10px;
        }

        .country-select-wrapper {
          position: relative;
          width: 130px;
          flex-shrink: 0;
        }

        .input-icon-left {
          position: absolute;
          left: 10px;
          top: 50%;
          transform: translateY(-50%);
          color: var(--text-color);
          opacity: 0.7;
          z-index: 2;
        }

        .country-select {
          width: 100%;
          padding: 15px 15px 15px 35px !important;
          appearance: none;
          background: var(--bg-color) !important;
          color: var(--text-color);
          direction: ltr;
        }
          
        .country-select option {
          background: var(--card-bg);
          color: var(--text-color);
        }

        .input-icon {
          position: absolute;
          right: 20px;
          color: var(--text-color);
          opacity: 0.7;
          transition: color 0.3s;
        }

        .input-group input, .input-group select {
          width: 100%;
          padding: 15px 50px 15px 20px;
          background: var(--bg-color);
          border: 1px solid var(--border-color);
          border-radius: 12px;
          color: var(--text-color);
          font-size: 15px;
          transition: all 0.3s ease;
        }

        .input-group input:focus, .input-group select:focus {
          outline: none;
          border-color: var(--primary);
          background: var(--card-bg);
          box-shadow: 0 0 15px rgba(255, 107, 53, 0.2);
        }

        .input-group input:focus + .input-icon {
          color: var(--primary);
        }

        .terms-checkbox-group {
          display: flex;
          align-items: center;
          gap: 10px;
          font-size: 14px;
          color: var(--text-color);
          opacity: 0.8;
          margin-top: 5px;
        }

        .terms-checkbox-group input[type="checkbox"] {
          width: 18px;
          height: 18px;
          accent-color: var(--primary);
          cursor: pointer;
        }

        .terms-link {
          color: var(--primary);
          text-decoration: underline;
          cursor: pointer;
          font-weight: bold;
        }
          
        .terms-link:hover {
          color: var(--secondary);
        }

        .auth-btn {
          padding: 15px;
          background: linear-gradient(135deg, var(--primary) 0%, var(--secondary) 100%);
          color: white;
          border: none;
          border-radius: 12px;
          font-size: 16px;
          font-weight: 700;
          cursor: pointer;
          transition: all 0.3s ease;
          display: flex;
          justify-content: center;
          align-items: center;
          box-shadow: 0 4px 15px rgba(255, 107, 53, 0.4);
        }

        .auth-btn:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(255, 107, 53, 0.6);
        }

        .auth-btn:disabled {
          background: #475569;
          box-shadow: none;
          cursor: not-allowed;
          opacity: 0.7;
        }

        .auth-footer {
          margin-top: 25px;
          text-align: center;
          color: var(--text-color);
          opacity: 0.7;
          font-size: 15px;
        }

        .auth-footer a {
          color: var(--primary);
          font-weight: 600;
          text-decoration: none;
          margin-right: 5px;
          transition: color 0.3s;
        }

        .auth-footer a:hover {
          color: var(--secondary);
        }

        .error-message {
          background: rgba(239, 68, 68, 0.1);
          color: #f87171;
          padding: 12px;
          border-radius: 8px;
          text-align: center;
          font-size: 14px;
          border: 1px solid rgba(239, 68, 68, 0.2);
        }

        .spinner {
          width: 20px;
          height: 20px;
          border: 3px solid rgba(255,255,255,0.3);
          border-radius: 50%;
          border-top-color: white;
          animation: spin 1s ease-in-out infinite;
        }

        /* Terms Modal */
        .terms-modal-overlay {
          position: fixed;
          top: 0; left: 0; width: 100vw; height: 100vh;
          background: rgba(0,0,0,0.6);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1000;
          backdrop-filter: blur(5px);
        }

        .terms-modal-content {
          width: 90%;
          max-width: 800px;
          max-height: 90vh;
          padding: 30px;
          position: relative;
          display: flex;
          flex-direction: column;
          background: var(--card-bg);
          color: var(--text-color);
        }

        .close-btn {
          position: absolute;
          top: 15px;
          left: 15px;
          background: none;
          border: none;
          color: var(--text-color);
          opacity: 0.7;
          font-size: 24px;
          cursor: pointer;
          transition: color 0.3s;
        }

        .close-btn:hover { 
          color: var(--text-color); 
          opacity: 1;
        }

        .terms-modal-content h2 {
          text-align: center;
          color: var(--primary);
          margin-bottom: 20px;
        }

        .terms-body {
          flex: 1;
          overflow-y: auto;
          padding-right: 15px;
          margin-bottom: 20px;
        }

        .terms-section h3 {
          color: var(--text-color);
          margin-top: 15px;
          margin-bottom: 10px;
        }

        .terms-section p {
          color: var(--text-color);
          opacity: 0.8;
          font-size: 15px;
          line-height: 1.6;
          margin-bottom: 10px;
        }

        .terms-section hr {
          border: none;
          border-top: 1px solid var(--border-color);
          margin: 30px 0;
        }

        .modal-action {
          width: 100%;
          padding: 15px;
          border-radius: 12px;
          font-size: 16px;
          font-weight: bold;
          border: none;
          cursor: pointer;
          background: var(--primary);
          color: white;
          transition: background 0.3s;
        }

        .modal-action:hover {
          background: var(--secondary);
        }

        @keyframes slideUp {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }

        @keyframes spin {
          to { transform: rotate(360deg); }
        }

        @media (max-width: 600px) {
          .auth-container { padding: 30px 20px; }
          .phone-group { flex-direction: column; }
          .country-select-wrapper { width: 100%; }
        }
      `}</style>
    </div>
  );
}

export default SignUp;